import { Center } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { ContentContainer } from '../ContentContainer/ContentContainer';

export const AuthLayout = ({ children }: PropsWithChildren) => {
	return (
		<Center flex={1} h="100%" w="100%">
			<ContentContainer maxW="breakpoint-lg">
				{children}
			</ContentContainer>
		</Center>
	);
};
